import {
  BrowserRouter as Router,
  Routes,
  Route,
  useSearchParams,
} from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import WellcomeScreen from "./screens/wellcomeScreen";
import PhoneNumberVerificationScreen from "./screens/phoneNumberVerificationScreen";

import Sections from "./screens/sections";
import Items from "./screens/Item";
import { useEffect, useState } from "react";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Arabic from "./languages/Arabic.json";
import English from "./languages/English.json";
import French from "./languages/French.json";
import Chinese from "./languages/Chinese.json";
import Catalan from "./languages/Catalan.json";
import Croatian from "./languages/Croatian.json";
import Czech from "./languages/Czech.json";
import Danish from "./languages/Danish.json";
import Dutch from "./languages/Dutch.json";
import Estonian from "./languages/Estonian.json";
import German from "./languages/German.json";
import Hungarian from "./languages/Hungarian.json";
import Italian from "./languages/Italian.json";
import Macedonian from "./languages/Macedonian.json";
import Norwegian from "./languages/Norwegian.json";
import Persian from "./languages/Persian.json";
import PortuguesePr from "./languages/Portuguese-pt.json";
import PortugueseBr from "./languages/Portuguese-br.json";
import Romanian from "./languages/Romanian.json";
import Russian from "./languages/Russian.json";
import Japanese from "./languages/Japanese.json";
import Spanish from "./languages/Spanish.json";
import Turkish from "./languages/Turkish.json";
import Ukranian from "./languages/Ukranian.json";
import Swedish from "./languages/Swedish.json";
import Korean from "./languages/Korean.json";
import Processing from "./screens/processing";
import NotFound from "./screens/notFound";

import FeedBack from "./screens/feedback";
import { QueryClient, QueryClientProvider } from "react-query";
import { AllLanguagesCode, getAndSaveTimeZone, getAuth, getLocalStorageMenuItem, ISDARKTHEME, setLocalStorageMenuItem, setMobileBackColor, setMobileSettings } from "./utility";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Favorites from "./screens/favorites";
import Cart from "./screens/cart";
import Orders from "./screens/orders";
import OrderDetails from "./screens/orderDetails";
import axios from "axios";
import Loading from "./common/loading";
import TawkToChat from "./tawkToChat ";
import OrderStatusTrack from "./screens/orderStatusTrack";
import MobilePaymentprocessing from "./screens/mobilePaymentprocessing";
import Profile from "./screens/profile";
import BottomNavBar from "./components/BottomNavBar";
import LabelsScreen from "./screens/labelsScreen";
import { use } from "react";
import OrderThanksScreen from "./screens/orderThanksScreen";
import PrivacyPolicy from "./screens/privacy_policy";
import TermsAndConditions from "./screens/terms_and_conditions";
import Transactions from "./screens/Transactions";
import InstallPrompt from "./components/InstallPrompt";

const language = AllLanguagesCode.filter((lang) => {
  return navigator.language.includes(lang);
});

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: English,
      },
      ar: {
        translation: Arabic,
      },
      fr: {
        translation: French,
      },
      "zh-Hans": {
        translation: Chinese,
      },
      ca: {
        translation: Catalan,
      },
      hr: {
        translation: Croatian,
      },
      cs: {
        translation: Czech,
      },
      da: {
        translation: Danish,
      },
      nl: {
        translation: Dutch,
      },
      et: {
        translation: Estonian,
      },
      de: {
        translation: German,
      },
      hu: {
        translation: Hungarian,
      },
      it: {
        translation: Italian,
      },
      mk: {
        translation: Macedonian,
      },
      nb: {
        translation: Norwegian,
      },
      fa: {
        translation: Persian,
      },
      pt: {
        translation: PortugueseBr,
      },
      "pt-pt": {
        translation: PortuguesePr,
      },
      ro: {
        translation: Romanian,
      },
      ru: {
        translation: Russian,
      },
      ja: {
        translation: Japanese,
      },
      es: {
        translation: Spanish,
      },
      tr: {
        translation: Turkish,
      },
      uk: {
        translation: Ukranian,
      },
      ko: {
        translation: Korean,
      },
      sv: {
        translation: Swedish,
      },
    },
    lng: getLocalStorageMenuItem("lang") || language, // if you're using a language detector, do not define the lng option
    fallbackLng: "en",

    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });

function App() {
  const location = window.location.href;
  const array = location.split("/");
  const qr = array[array.length - 2];
  const qrName = array[array.length - 3];

  const queryClient = new QueryClient();
  const [loadingTree, setLoadingTree] = useState(false);
  const [allTreeData, setAllTreeData] = useState(getLocalStorageMenuItem("tree_data") || [])

  const [lang, setLang] = useState();

  useEffect(() => {

    getAndSaveTimeZone();
    if (
      getLocalStorageMenuItem("lang") === "ar" ||
      getLocalStorageMenuItem("lang") === "fa"
    ) {
      document.body.classList.add("arabic-font");
      document.body.classList.remove("latino-font");

      setLang("arabic-font");
    } else {
      document.body.classList.add("latino-font");
      document.body.classList.remove("arabic-font");
      setLang("latino-font");
    }
  }, [getLocalStorageMenuItem("lang")]);

  const loadTree = async () => {
    setLoadingTree(true);
    try {
      const timeZone = getLocalStorageMenuItem("timezone") || "";
      const promise = await axios.get(
        `${process.env.REACT_APP_API}/menus/${qr}/public-tree`,
        {
          headers: {
            localization: getLocalStorageMenuItem("lang") || "",
            timeZone: timeZone?.replace(/["]+/g, ''),
          },
        }
      );
      setLocalStorageMenuItem(
        "tree_data",
        JSON.stringify(promise?.data?.data ? promise?.data?.data : [])
      );
      setAllTreeData(promise?.data?.data ? promise?.data?.data : []);
      setMobileSettings(promise?.data?.data?.details)
      return promise?.data?.data;
    } catch (error) {
    } finally {
      setLoadingTree(false);
    }
  }

  useEffect(() => {
    //prod -  test_prod - local
    setLocalStorageMenuItem("prod_mode", "prod");
    // localStorage.clear();
    // if (performance.getEntriesByType("navigation")[0].type === "reload") {
    //   loadTree();
    // }
  }, []);



  useEffect(() => {
    if (getLocalStorageMenuItem("mode") === "dark") {
      document.body.classList.add("dark");
      document.body.classList.remove("light");
    } else {
      document.body.classList.add("light");
      document.body.classList.remove("dark");
    }
  }, [getLocalStorageMenuItem("mode")]);

  if (loadingTree) {
    return <Loading backColor={setMobileBackColor()} />;
  }

  return (

    <div translate="no">
      <GoogleOAuthProvider clientId="987046823583-0i3q2mn69kg3qgr838jb0hes433vn67e.apps.googleusercontent.com">
        <QueryClientProvider client={queryClient}>
          <Router>
            <TawkToChat />
            <Routes>
              <Route path="/trackorderstatus" element={<OrderStatusTrack />} />
              <Route
                path={`/:qrName/:qrCode/sections`}
                element={<Sections tableName={qrName} tableQr={qr} />}
              />

              <Route
                path={`/:qrName/:qrCode/labels`}
                element={<LabelsScreen tableName={qrName} tableQr={qr} />}
              />

              <Route
                path={`/:qrName/:qrCode/mobilePaymentprocessing`}
                element={<MobilePaymentprocessing tableName={qrName} tableQr={qr} />}
              />

              <Route
                path={`/:qrName/:qrCode/verify-phone`}
                element={<PhoneNumberVerificationScreen tableName={qrName} tableQr={qr} />}
              />
              <Route
                path={`/:qrName/:qrCode/items`}
                element={<Items tableName={qrName} tableQr={qr} />}
              />
              <Route
                path={`/:qrName/:qrCode/feedback`}
                element={<FeedBack tableName={qrName} tableQr={qr} />}
              />
              <Route
                path={`/:qrName/:qrCode/orders`}
                element={<Orders tableName={qrName} tableQr={qr} />}
              />
              <Route
                path={`/:qrName/:qrCode/order_thanks`}
                element={<OrderThanksScreen tableName={qrName} tableQr={qr} />}
              />
              <Route
                path={`/:qrName/:qrCode/order-details`}
                element={<OrderDetails tableName={qrName} tableQr={qr} />}
              />
              <Route
                path={`/:qrName/:qrCode/favorites`}
                element={<Favorites tableName={qrName} tableQr={qr} />}
              />
              <Route
                path={`/:qrName/:qrCode/cart`}
                element={<Cart tableName={qrName} tableQr={qr} />}
              />
              <Route
                path={`/${qrName}/${qr}/menus`}
                element={<WellcomeScreen tableName={qrName} tableQr={qr} />}
              />

              <Route
                path={`/${qrName}/${qr}/profile`}
                element={<Profile tableName={qrName} tableQr={qr} />}
              />
              <Route
                path={`/:qrName/:qrCode/transactions`}
                element={<Transactions tableName={qrName} tableQr={qr} />}
              />

              <Route
                path={`/${qrName}/${qr}/privacy-policy`}
                element={<PrivacyPolicy tableName={qrName} tableQr={qr} />}
              />

              <Route
                path={`/${qrName}/${qr}/terms-and-conditions`}
                element={<TermsAndConditions tableName={qrName} tableQr={qr} />}
              />

              <Route path="*" element={<NotFound />} />
            </Routes>
            {/* <BottomNavBar qr={qr} qrName={qrName} /> */}

          </Router>
        </QueryClientProvider>
      </GoogleOAuthProvider>
    </div>



  );
}

export default App;
